document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('one-up-search');
  const typeCheckboxes = document.querySelectorAll('.one-up-type-checkbox');
  const resetBtn = document.getElementById('one-up-reset');

  // Helper to format money for the UI (GBP)
  function formatShopifyMoney(cents) {
    return (cents / 100).toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP',
    });
  }

  function filterRows() {
    const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const checkedTypes = Array.from(document.querySelectorAll('.one-up-type-checkbox:checked')).map(cb => cb.value);
    const variantRows = document.querySelectorAll('.variant-row');
    const productHeaders = document.querySelectorAll('.product-header-row');

    variantRows.forEach(row => {
      const matchesSearch = row.getAttribute('data-search-string').includes(searchTerm);
      const matchesType = checkedTypes.length === 0 || checkedTypes.includes(row.getAttribute('data-product-type'));
      row.style.display = (matchesSearch && matchesType) ? '' : 'none';
    });

    productHeaders.forEach(header => {
      const pid = header.getAttribute('data-product-id');
      const hasVisible = document.querySelectorAll(`.variant-row[data-product-id="${pid}"]:not([style*="display: none"])`).length > 0;
      header.style.display = hasVisible ? '' : 'none';
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (searchInput) searchInput.value = '';
      typeCheckboxes.forEach(cb => cb.checked = false);
      filterRows();
    });
  }

  if (searchInput) searchInput.addEventListener('input', filterRows);
  typeCheckboxes.forEach(cb => cb.addEventListener('change', filterRows));

  const qtyInputs = document.querySelectorAll('.one-up-qty-input');
  
  qtyInputs.forEach(input => {
    input.addEventListener('change', function() {
      const variantId = this.dataset.variantId;
      const customPrice = this.dataset.customPrice.replace(/[£,]/g, '');
      const maxInv = parseInt(this.dataset.inventory, 10) || 0;
      let qty = parseInt(this.value, 10) || 0;

      if (qty > maxInv) {
        alert(`Stock limit reached. Setting quantity to ${maxInv}.`);
        qty = maxInv;
        this.value = maxInv;
      }

      this.disabled = true;
      this.style.opacity = '0.5';

      /* --- THE FIX ---
         We use /cart/add.js but with a small twist: 
         Shopify's AJAX API treats 'add' as cumulative. 
         To make it 'absolute', we first use /update.js to set the qty, 
         then /add.js to ensure the property is attached if it's a new addition.
         
         ACTUALLY, the cleanest way for a single-item absolute update with properties
         is to use /cart/add.js but set the quantity via a 'change' logic flow.
      */

      // Step 1: Set the quantity to 0 first to clear the old property/qty state
      // Step 2: Add back the exact quantity with the property
      // This prevents the "additive" 1+2+3=6 issue.
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId.toString(),
          quantity: 0
        })
      })
      .then(() => {
        if (qty > 0) {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: qty,
                properties: { "dealerPricing": customPrice }
              }]
            })
          });
        } else {
          return fetch(window.Shopify.routes.root + 'cart.js');
        }
      })
      .then(response => response.json())
      .then(() => fetch(window.Shopify.routes.root + 'cart.js')) // Final fetch to get clean state
      .then(res => res.json())
      .then(cart => {
        const counter = document.getElementById('one-up-floating-count');
        const totalContainer = document.getElementById('one-up-floating-total');
        if (counter) counter.textContent = cart.item_count;
        if (totalContainer) totalContainer.textContent = formatShopifyMoney(cart.total_price);

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        this.disabled = false;
        this.style.opacity = '1';
      })
      .catch(err => {
        console.error('Cart Error:', err);
        this.disabled = false;
        this.style.opacity = '1';
      });
    });
  });
});